module.exports = __webpack_public_path__ + "static/img/bcg.c80a7488.webp";